import { render, staticRenderFns } from "./SelectPlan.vue?vue&type=template&id=7b0eaa70"
import script from "./SelectPlan.vue?vue&type=script&lang=js"
export * from "./SelectPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b0eaa70')) {
      api.createRecord('7b0eaa70', component.options)
    } else {
      api.reload('7b0eaa70', component.options)
    }
    module.hot.accept("./SelectPlan.vue?vue&type=template&id=7b0eaa70", function () {
      api.rerender('7b0eaa70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment/SelectPlan.vue"
export default component.exports